export default (axios, baseURL) => ({
  list(type, params = {}) {
    return axios.get(`${baseURL}/api/public/benefit-catalogs/${type}`, { params });
  },
  import(type, file) {
    const data = new FormData();
    data.append('file', file);
    return axios.post(`${baseURL}/api/benefit-catalogs/${type}/import`, data);
  },
});
